import { render, staticRenderFns } from "./BeBasketSummaryString.vue?vue&type=template&id=5cd2e9bc&scoped=true"
import script from "./BeBasketSummaryString.vue?vue&type=script&lang=js"
export * from "./BeBasketSummaryString.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd2e9bc",
  null
  
)

export default component.exports